import React, { Component } from 'react';
import { MarkerLayer } from '../../../../../../lib/Map';
import { inject, observer } from 'mobx-react';
import { withTheme } from '@material-ui/core';
import { getAnchorPointMarker } from './utils';
import { AnchorPointPopup } from './components';

@inject('CommonStore')
@observer
class AnchorPointLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnchorPoint: null
    };
  }

  componentDidMount() {
    this.props.glEventHub.on('clearAnchorPointPopup', this.clearSelectedAnchorPoint);
  }

  componentWillUnmount() {
    this.props.glEventHub.off('clearAnchorPointPopup', this.clearSelectedAnchorPoint);
  }

  clearSelectedAnchorPoint = () => {
    if (this.state.selectedAnchorPoint) {
      this.setState({
        selectedAnchorPoint: null
      });
    }
  };

  getAnchorPointIcon = (anchorPoint) => {
    return getAnchorPointMarker({
      anchorPointData: anchorPoint,
      markerSize: "35px",
      theme: this.props.theme,
      isDisabledAnchorPoint: !Boolean(anchorPoint.routeAssigned),
      isActiveAnchorPoint:
        this.state.selectedAnchorPoint?.anchorPointName === anchorPoint.anchorPointName
    });
  };

  handleMarkerClick = (anchorPoint) => {
    this.setState({
      selectedAnchorPoint: anchorPoint
    });
  };

  getFilteredAnchorPointData = () => {
    const {
      CommonStore: { anchorPointData },
      selectedRoutesAnchorPointList,
    } = this.props;
    return anchorPointData.anchorPointList
      ? anchorPointData.anchorPointList
          .filter(
            (anchorPoint) =>
              // Show only selected anchor points that are open on the current plan date, and not selected in any of the selected routes
              anchorPoint.isSelected &&
              !selectedRoutesAnchorPointList.includes(anchorPoint.anchorPointName)
          )
          .slice()
      : [];
  };

  render() {
    return (
      <div>
        <MarkerLayer
          data={this.getFilteredAnchorPointData()}
          dataKey="anchorPointName"
          activeMarkerIds={
            this.state.selectedAnchorPoint ? [this.state.selectedAnchorPoint.anchorPointName] : []
          }
          getIcon={this.getAnchorPointIcon}
          onClick={this.handleMarkerClick}
          showTooltip
          styleName={this.props.styleName}
        />
        {this.state.selectedAnchorPoint && (
          <AnchorPointPopup
            anchorPointInfo={this.state.selectedAnchorPoint}
            theme={this.props.theme}
            showNotification={this.props.showNotification}
            refreshData={this.props.refreshData}
          />
        )}
      </div>
    );
  }
}

export default withTheme()(AnchorPointLayer);
